import { isFunction, isNonEmptyString, isNumber } from "@/utils";

export class FormikHelper {
  static handleNumberChange = (
    newValueStr: string,
    propertyName: string,
    setFieldValue: (
      field: string,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      value: any,
      shouldValidate?: boolean | undefined
    ) => void,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseFn?: (str?: any) => number | undefined,
    reTest?: RegExp
  ) => {
    if (isNumber(newValueStr)) {
      setFieldValue(propertyName, newValueStr);
      return;
    }

    let newValue = undefined;

    if (!isNonEmptyString(newValueStr)) {
      setFieldValue(propertyName, newValue);
      return;
    }

    if (!reTest || !reTest!.test(newValueStr)) {
      return;
    }

    if (isFunction(parseFn)) {
      newValue = parseFn?.(newValueStr);

      if (!isNumber(newValue as number)) {
        newValue = undefined;
      }
    } else {
      newValue = newValueStr;
    }

    setFieldValue(propertyName, newValue);
  };
}
